import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private cookieService: CookieService) {}

  securelyStoreUserId(userId: string): void {
    this.cookieService.set('userId', userId, 1, '/', undefined, true, 'Strict');
  }

  getUserId(): string {
    return this.cookieService.get('userId');
  }

  securelyStoreToken(tokenName: string, tokenValue: string): void {
    this.cookieService.set(tokenName, tokenValue, 1, '/', undefined, true, 'Strict');
  }

  getToken(tokenName: string): string {
    return this.cookieService.get(tokenName);
  }

  clearAllTokens(): void {
    this.cookieService.deleteAll('/');
  }
}
